var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVivoHeartLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 255.1 83.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n        stroke: url(#linear-gradient);\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 1.1px;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 41.8,
    x2: 255.1,
    y2: 41.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f569d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3e9cb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#479fa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#60a98b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#88b95b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a5c539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#b2cb2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e2e10d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f5ea00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f2d108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ec931f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#eb8923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#e97e23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#e76224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e23525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e22e26"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.6,41.4c0,70.1-56.9,30.4-127,30.4S.5,111.5.5,41.4,57.4,12.7,127.5,12.7s127-41.5,127,28.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.6,25.4h4.5c.5,0,.9.1,1.2.4.3.2.5.5.7.9l7.1,18.4c.2.6.5,1.3.7,2,.2.7.4,1.5.6,2.3.3-1.6.7-3,1.2-4.2l7.1-18.4c.1-.3.3-.6.7-.9s.7-.4,1.2-.4h4.5l-12.2,30.1h-5.1l-12.2-30.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.1,27.9c0,.4,0,.9-.3,1.2s-.4.7-.7,1-.6.5-1.1.7c-.4.2-.8.3-1.3.3s-.9,0-1.3-.3c-.4-.2-.7-.4-1-.7-.3-.3-.5-.6-.7-1-.2-.4-.3-.8-.3-1.2s0-.9.3-1.3c.2-.4.4-.8.7-1,.3-.3.6-.5,1-.7.4-.2.8-.3,1.3-.3s.9,0,1.3.3c.4.2.8.4,1.1.7s.5.6.7,1,.3.8.3,1.3ZM60.3,34.1v21.4h-5.1v-21.4h5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.9,55.5h-4.7l-8.5-21.4h4.3c.4,0,.7,0,.9.3.3.2.4.4.5.7l4.1,11.4c.2.7.4,1.3.6,2,.2.6.3,1.3.4,1.9.1-.6.3-1.3.4-1.9.2-.6.4-1.3.6-2l4.2-11.4c0-.3.3-.5.5-.7.2-.2.5-.3.9-.3h4.1l-8.5,21.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.8,33.8c1.6,0,3,.3,4.3.8,1.3.5,2.4,1.2,3.3,2.2s1.6,2.1,2.1,3.5c.5,1.4.8,2.9.8,4.6s-.2,3.2-.8,4.6c-.5,1.4-1.2,2.5-2.1,3.5-.9,1-2,1.7-3.3,2.2-1.3.5-2.7.8-4.3.8s-3-.3-4.4-.8c-1.3-.5-2.4-1.2-3.3-2.2-.9-1-1.6-2.1-2.1-3.5-.5-1.4-.8-2.9-.8-4.6s.3-3.2.8-4.6c.5-1.4,1.2-2.5,2.1-3.5.9-.9,2-1.7,3.3-2.2,1.3-.5,2.8-.8,4.4-.8ZM96.8,51.9c1.8,0,3.1-.6,3.9-1.8.9-1.2,1.3-2.9,1.3-5.2s-.4-4.1-1.3-5.3c-.9-1.2-2.2-1.8-3.9-1.8s-3.1.6-4,1.8c-.9,1.2-1.3,3-1.3,5.3s.4,4,1.3,5.2c.9,1.2,2.2,1.8,4,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.1,55.5h-5.6v-13.2h-14.1v13.2h-5.6v-30.1h5.6v13h14.1v-13h5.6v30.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.7,33.8c1.3,0,2.6.2,3.7.6,1.1.4,2.1,1.1,2.9,1.9s1.5,1.8,1.9,3c.5,1.2.7,2.6.7,4.1s0,.7,0,1c0,.3,0,.5-.2.6,0,.1-.2.2-.4.3-.2,0-.3,0-.6,0h-13.2c.2,2.2.7,3.8,1.8,4.8,1,1,2.4,1.5,4.1,1.5s1.6,0,2.2-.3c.6-.2,1.1-.4,1.6-.6.5-.2.8-.5,1.2-.6.3-.2.7-.3,1-.3s.4,0,.5.1c.2,0,.3.2.4.4l1.5,1.9c-.6.7-1.2,1.2-1.9,1.7-.7.5-1.4.8-2.2,1.1-.8.3-1.6.5-2.4.6-.8.1-1.6.2-2.3.2-1.5,0-2.9-.2-4.1-.7-1.3-.5-2.4-1.2-3.3-2.2-.9-1-1.7-2.2-2.2-3.6-.5-1.4-.8-3.1-.8-4.9s.2-2.8.7-4.1c.5-1.3,1.1-2.4,2-3.4s2-1.7,3.2-2.3c1.3-.6,2.7-.8,4.3-.8ZM151.8,37.5c-1.5,0-2.7.4-3.5,1.3-.8.8-1.4,2-1.6,3.6h9.7c0-.7,0-1.3-.3-1.9-.2-.6-.5-1.1-.8-1.6-.4-.4-.8-.8-1.4-1.1-.6-.3-1.2-.4-2-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.9,55.5h-2.3c-.5,0-.9,0-1.1-.2-.3-.1-.5-.4-.6-.9l-.5-1.5c-.5.5-1.1.9-1.6,1.3-.5.4-1.1.7-1.6.9s-1.1.4-1.8.6-1.3.2-2.1.2-1.7-.1-2.5-.4c-.8-.2-1.4-.6-2-1.1-.5-.5-1-1.1-1.3-1.8s-.5-1.6-.5-2.5.2-1.6.6-2.4c.4-.8,1.1-1.5,2.1-2.1,1-.6,2.3-1.2,3.9-1.6,1.6-.4,3.7-.6,6.1-.6v-1.3c0-1.4-.3-2.5-.9-3.2-.6-.7-1.5-1-2.6-1s-1.5,0-2.1.3-1,.4-1.4.7c-.4.2-.8.5-1.1.7-.3.2-.7.3-1.1.3s-.6,0-.9-.3c-.2-.2-.5-.4-.6-.7l-.9-1.6c2.5-2.2,5.4-3.4,8.9-3.4s2.4.2,3.3.6c1,.4,1.8,1,2.5,1.7.7.7,1.2,1.6,1.6,2.6.4,1,.5,2.1.5,3.3v13.5ZM171.9,52.3c.5,0,1,0,1.5-.1.4,0,.9-.2,1.3-.4.4-.2.8-.4,1.1-.7s.7-.6,1.1-1v-3.6c-1.5,0-2.8,0-3.8.3-1,.2-1.8.4-2.4.7-.6.3-1,.6-1.3,1s-.4.8-.4,1.3c0,.9.3,1.6.8,2,.5.4,1.2.6,2.1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.9,55.5v-21.4h3c.5,0,.9,0,1.1.3s.3.5.4,1l.3,2.6c.8-1.3,1.7-2.4,2.7-3.1,1-.8,2.2-1.1,3.5-1.1s1.9.2,2.6.7l-.7,3.9c0,.2-.1.4-.3.5-.1.1-.3.2-.6.2s-.5,0-.9-.1c-.4,0-.8-.1-1.4-.1-1.1,0-2,.3-2.7.9s-1.4,1.5-1.9,2.6v13.3h-5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211,55.8c-1.8,0-3.3-.5-4.3-1.6s-1.5-2.5-1.5-4.3v-11.9h-2.2c-.3,0-.5,0-.7-.3-.2-.2-.3-.5-.3-.8v-2l3.4-.6,1.1-5.8c0-.3.2-.5.4-.6.2-.2.5-.2.8-.2h2.7v6.7h5.6v3.7h-5.6v11.6c0,.7.2,1.2.5,1.6s.8.6,1.3.6.6,0,.8-.1c.2,0,.4-.2.6-.2s.3-.2.4-.2c.1,0,.2-.1.4-.1s.3,0,.4.1c0,0,.2.2.3.3l1.5,2.5c-.8.6-1.6,1.1-2.6,1.4-1,.3-2,.5-3,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218,32.8c0-.8.1-1.6.3-2.4.2-.8.5-1.5.9-2.1.4-.7.9-1.3,1.4-1.8.5-.5,1.2-1,1.8-1.4.7-.4,1.4-.7,2.1-.9.8-.2,1.6-.3,2.4-.3s1.6.1,2.4.3c.8.2,1.5.5,2.1.9.7.4,1.3.9,1.8,1.4s1,1.2,1.4,1.8c.4.7.7,1.4.9,2.1.2.8.3,1.6.3,2.4s-.1,1.6-.3,2.4c-.2.8-.5,1.5-.9,2.1s-.9,1.3-1.4,1.8c-.5.5-1.2,1-1.8,1.4s-1.4.7-2.1.9c-.8.2-1.6.3-2.4.3s-1.6-.1-2.4-.3-1.5-.5-2.1-.9c-.7-.4-1.3-.9-1.8-1.4-.5-.5-1-1.1-1.4-1.8s-.7-1.4-.9-2.1c-.2-.8-.3-1.6-.3-2.4ZM219.6,32.8c0,1.1.2,2,.6,3,.4.9.9,1.7,1.6,2.4.7.7,1.4,1.2,2.3,1.6.9.4,1.9.6,2.9.6s2-.2,2.9-.6c.9-.4,1.7-.9,2.3-1.6.7-.7,1.2-1.5,1.6-2.4.4-.9.6-1.9.6-3s0-1.4-.3-2c-.2-.6-.4-1.3-.7-1.8-.3-.6-.7-1.1-1.1-1.5s-.9-.9-1.5-1.2c-.5-.3-1.1-.6-1.8-.8-.6-.2-1.3-.3-2-.3s-1.3,0-2,.3c-.6.2-1.2.4-1.8.8-.5.3-1,.7-1.5,1.2s-.8,1-1.1,1.5c-.3.6-.6,1.2-.7,1.8-.2.6-.3,1.3-.3,2ZM225.6,34.3v3.9h-2.6v-10.9h3.9c1.5,0,2.6.3,3.3.8.7.5,1.1,1.3,1.1,2.3s-.2,1.4-.6,1.9c-.4.5-1,.9-1.7,1.2.2.1.3.2.5.4.1.2.2.3.4.6l2.2,3.7h-2.5c-.4,0-.6-.1-.8-.4l-1.7-3.2c0-.1-.2-.2-.3-.3-.1,0-.3,0-.5,0h-.7ZM225.6,32.5h1.1c.4,0,.8,0,1-.1s.5-.2.6-.3c.2-.1.3-.3.3-.5,0-.2,0-.4,0-.7s0-.5,0-.7c0-.2-.1-.3-.3-.5s-.3-.2-.6-.3c-.2,0-.5,0-.9,0h-1.3v3.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVivoHeartLogo);
export default __webpack_public_path__ + "static/media/VivoHeartLogo.fb8a45f34b00b5051be7e87709a0938d.svg";
export { ForwardRef as ReactComponent };